export default __webpack_public_path__ + "df6771b8f20354cbded3eb7182e88861.png";